import { css } from '@emotion/react';
import { tokens } from '../tokens';
import { overlayEnter, overlayExit } from './keyframes';
var overlayStaticStyle = css({
    alignItems: 'center',
    backgroundColor: tokens.colors.navy70,
    display: 'flex',
    justifyContent: 'center',
    opacity: 0,
    padding: tokens.spacing.medium,
    zIndex: tokens.zIndex.overlay,
});
export function overlayStyle(_a) {
    var isVisible = _a.isVisible;
    return [
        overlayStaticStyle,
        css({
            animation: "".concat(isVisible ? overlayEnter : overlayExit, " 200ms ease-out forwards"),
        }),
    ];
}
